<template>
  <div v-if="recordingRoom" v-show="show" class="indicator">
    <img src="../assets/img/icons/record-cam.svg" width="24" height="18" alt="" />
    <span class="indicator__hint">Идет запись</span>
    <!-- FIY: Попап с текстом "Не забудьте уведомить кандидата, что идет запись", если его решат вернуть -->
    <!-- <div v-if="showRecordBubble && user.isCandidate.value === false" class="indicator__popup ">
      <span class="indicator__popup-message">
        {{ $t('notifyAboutRecord') }}
      </span>
      <button class="indicator__popup-btn indicator__popup-btn_close" @click="closeRecordBubble" />
    </div> -->
  </div>
</template>

<script>
import { ref } from '@vue/composition-api';
import useRoom from '@/compositions/useRoom';

export default {
  name: 'RecordIndicator',
  setup() {
    const { recordingRoom, user } = useRoom();
    const show = ref(true);
    const showRecordBubble = ref(true);

    setTimeout(() => {
      showRecordBubble.value = false;
    }, 10 * 1000);

    function closeRecordBubble() {
      showRecordBubble.value = false;
    }

    return {
      recordingRoom,
      show,
      showRecordBubble,
      closeRecordBubble,
      user,
    };
  },
};
</script>

<style lang="scss" scoped>
  .indicator {
    width: 4.375rem;
    font-size: 0.75rem;
    line-height: 1.67;
    color: #B24141;
    text-align: center;
    svg {
      display: block;
      margin: 0 auto 0.3125rem;
    }
    &__hint {
      font-size: 12px;
    }
    &__popup {
    position: absolute;
    top: calc(100% + 13px);
    color: black;
    background: white;
    font-weight: 500;
    border-radius: 5px;
    min-width: 260px;
    padding: 15px 10px;
    &-message {
      font-size: 14px;
    }
    &-btn {
      padding: 0;
      border: none;
      &_close {
        position: absolute;
        width: 7px;
        height: 7px;
        top: 6px;
        right: 6px;
        background: white;
        &:before, &:after {
          content: '';
          position: absolute;
          left: 0;
          width: 8px;
          height: 1px;
          background: #757575;
        }
        &:before {
          transform: rotate(45deg);
        }
        &::after {
          transform: rotate(-45deg);
        }
      }
    }
    &:after {
      content: '';
      position: absolute;
      left: 27px;
      top: -5px;
      width: 14px;
      height: 14px;
      transform: rotate(45deg);
      background: white;
    }
  }
  }
  @media (max-width: 1199px) {
    .indicator {
      width: 4rem;
      font-size: 0.6875rem;
      line-height: 1.67;
      color: #B24141;
      text-align: center;
      img {
        display: block;
        margin: 0 auto 0.125rem;
      }
    }
  }
  @media (max-width: 959px) {
    .indicator {
      width: 1.5rem;
      font-size: 0;
      padding-top: 0;
      img {
        display: block;
        margin: 0 auto;
      }
    }
  }
  @media (max-width: 599px) {
    .indicator {
      width: 3.625rem;
      font-size: 0.625rem;
      line-height: 1;
      padding-top: 0.5rem;
      img {
        display: block;
        margin: 0 auto 0.625rem;
      }
      &__popup {
        &:after {
          left: 20px;
        }
      }
    }
  }
</style>

<i18n locale="en" lang="yaml">
recordInProgress: Recording in progress
notifyAboutRecord: Don't forget to notify the candidate before starting the recording.
</i18n>

<i18n locale="ru" lang="yaml">
recordInProgress: Идет запись
notifyAboutRecord: Не забудьте перед началом записи предупредить об этом кандидата
</i18n>
